import { ItemTypeValue } from "./ItemInitializers";

export const ItemTypeValues: ItemTypeValue[] = ['Item', 'Weapon', 'Mod', 'Ammo', 'Spell'];

export const IsItemTypeValue = (possibleType: string): possibleType is ItemTypeValue => {
    return ItemTypeValues.contains(possibleType);
}